import './PeriodControl.css'
import {useCallback, useEffect, useRef, useState} from "react";
import staticVariable from "./staticVariable";
import products from "../earth/1.0.0/products";
import _ from 'lodash';
// import _ from "underscore";
import µ from "../earth/1.0.0/micro";
import PeriodControlMobile from "./PeriodControlMobile";
import PeriodControlPc from "./PeriodControlPc";

const PeriodControl = ({ isMobile, earthController, menuDisplayToggle, climateData, mouseMode, setClearMouseModeAction, levelValue, overlayType, rightMenuToggle, windowSize }) => {
    const [showVicennialLocationAverage, setShowVicennialLocationAverage] = useState(false);
    const [showVicennialAreaMean, setShowVicennialAreaMean] = useState(false);
    const [primaryUnit, setPrimaryUnit] = useState({ label: 'm/s' });
    const [overlayUnit, setOverlayUnit] = useState({ label: '°C' });
    const [colorGradientList, setColorGradientList] = useState([]);
    const [periodValue, setPeriodValue] = useState(staticVariable.PERIOD_MAX / 2);
    const tbodyRef = useRef(null);
    const chartIntervalId = useRef(null);
    const [periodPlay, setPeriodPlay] = useState(false);
    const [interpolateWait, setInterpolateWait] = useState(0);
    const periodIntervalId = useRef(null);
    const waitIntervalId = useRef(null);
    const primaryWorker = useRef(null);
    const overlayWorker = useRef(null);
    //최초 렌더링할때 사이드이펙트
    useEffect(() => {
        if (earthController.configuration) {
            //화면 렌더링시 현재 기간을 PeriodValue에 세팅
            const configurationScenario = earthController.configuration.get("scenario");
            let startDate = products.scenarioPeriod(configurationScenario).startDate;
            startDate = new Date(Date.UTC(startDate.split("/")[0] * 1, 0, 1, 0, 0, 0)); // 1860/01/01
            const date = earthController.configuration.get("date") === "current"
                ? new Date(Math.floor(Date.now() / staticVariable.THREE_HOURS) * staticVariable.THREE_HOURS)
                : new Date(earthController.configuration.get("date"));
            let sliderValue = (date.getFullYear() - startDate.getFullYear()) * 12 + (date.getMonth() - startDate.getMonth());
            if (sliderValue > staticVariable.PERIOD_MAX) sliderValue = staticVariable.PERIOD_MAX;
            if (sliderValue < 0) sliderValue = 0;
            setPeriodValue(sliderValue);
            setPrimaryUnit(products.getUnitList('wind')[0]);
            setOverlayUnit(products.getUnitList(overlayType)[0])
        } // if (earthController.configuration) { end
    }, [earthController, overlayType])

    //overlay변경시 Unit을 세팅하기 위한 사이드 이펙트
    // useEffect(() => {
    //     console.log( overlayType, overlayType === 'slr');
    //         setPrimaryUnit(products.getUnitList('wind')[0]);
    //         setOverlayUnit(products.getUnitList(overlayType)[0])
    // }, [overlayType])



    useEffect(() => {
        if (climateData) {
            if (mouseMode === 'basic') {
                setShowVicennialLocationAverage(true);
                setShowVicennialAreaMean(false);
            } else if (mouseMode === 'crossSection') {
                setShowVicennialLocationAverage(false);
                setShowVicennialAreaMean(false);
            } else if (mouseMode === 'areaMean') {
                setShowVicennialLocationAverage(false);
                setShowVicennialAreaMean(true);
            } else {
                console.log('unknown mouseMode', mouseMode);
            }

            //영역평균 그레프 렌더링..
            var colorList = [];
            earthController.showTimeSeriesOverlayChart(climateData,"#overlay-chart", tbodyRef.current.clientWidth,isMobile ? 50 : 80, colorList);
            setColorGradientList(colorList);
        } else {
            setShowVicennialLocationAverage(false);
            setShowVicennialAreaMean(false);
        }
    }, [climateData])

    //윈도우 사이즈 변경, 설정메뉴 토글시 챠트를 다시 그리기 위한 사이드 이펙트
    useEffect(() => {
        if (climateData && showVicennialAreaMean) {
            //timeout을 쓰는 이유는 rightMenuToggle가 변경시 바로 tbody 사이즈가 변경되지 않고
            //오른쪽 메뉴가 슬라이드 되면서 나오기 떄문에 tbody 사이즈가 일정 시간이 지난후 변한다
            //이 변한 tbody 사이즈를 기준으로 챠트를 새로 그리기 위함이다.
            chartIntervalId.current = setTimeout(() => {
                earthController.showTimeSeriesOverlayChart(climateData,"#overlay-chart", tbodyRef.current.clientWidth,isMobile ? 50 : 80);
            }, 500);
        }
        return () => {
            clearTimeout(chartIntervalId.current)
        }
    }, [rightMenuToggle, windowSize])

    const getOverlayClassName = (isPrimary) => {
        if (climateData) {
            let type = overlayType;
            if (isPrimary) {
                if (earthController.configuration.get("param") === 'wind') return 'tp01'
                else return 'tp02'
            } else {
                if (type === 'wind') return "tp01"
                else if (type === 'currents') return 'tp02'
                else if (type === "sea_ice_area") return 'tp03'
                else if (type === "total_precipitable_water") return 'tp04'
                else if (type === 'temp') return 'tp05'
                else if (type === 'sst') return 'tp08'
                else if (type === 'salnt') return 'tp09'
                else if (type === 'od550aer') return 'tp10'
                else if (type === 'slr') return 'tp11'
            }
        } //if (climateData) { end
    }

    const getParamElement = (mode) => {
            let type = overlayType;
            if (type === 'currents') {
                return <div className="btma_tit01 cl">
                    <h2 className="tp02">해류</h2>
                    <h2 className="tp06">@surface</h2>
                </div>
            } else if (type === 'wind') {
                return <div className="btma_tit01 cl">
                    <h2 className="tp01">풍속</h2>
                    <h2 className="tp06">@{levelValue !== 0 ? staticVariable.LEVEL_LIST[levelValue].split('-')[1] : 'surface'}</h2>
                </div>
            } else if (type === 'temp') {
                return <div className="btma_tit01 cl">
                    {mode === 'basic' ? <h2 className="tp01">풍속</h2> : null}
                    {mode === 'basic' ? <p className="ze01">+</p> : null}
                    <h2 className="tp05">기온</h2>
                    <h2 className="tp06">@{levelValue !== 0 ? staticVariable.LEVEL_LIST[levelValue].split('-')[1] : 'surface'}</h2>
                </div>
            } else if (type === "total_precipitable_water") {
                return <div className="btma_tit01 cl">
                    {mode === 'basic' ? <h2 className="tp01">풍속</h2> : null}
                    {mode === 'basic' ? <p className="ze01">+</p> : null}      
                    <h2 className="tp04">강수</h2>
                    <h2 className="tp06">@surface</h2>
                </div>
            } else if (type === "sea_ice_area") {
                return <div className="btma_tit01 cl">
                    {mode === 'basic' ? <h2 className="tp02">해류</h2> : null}
                    {mode === 'basic' ? <p className="ze01">+</p> : null}
                    <h2 className="tp03">해빙</h2>
                    <h2 className="tp06">@surface</h2>
                </div>
            } else if (type === "od550aer") {
                return <div className="btma_tit01 cl">
                    {mode === 'basic' ? <h2 className="tp01">풍속</h2> : null}
                    {mode === 'basic' ? <p className="ze01">+</p> : null}
                    <h2 className="tp10">미세먼지</h2>
                    <h2 className="tp06">@surface</h2>
                </div>
            } else if (type === "salnt") {
                return <div className="btma_tit01 cl">
                    {mode === 'basic' ? <h2 className="tp02">해류</h2> : null}
                    {mode === 'basic' ? <p className="ze01">+</p> : null}
                    <h2 className="tp09">염분</h2>
                    <h2 className="tp06">@surface</h2>
                </div>
            } else if (type === "sst") {
                return <div className="btma_tit01 cl">
                    {mode === 'basic' ? <h2 className="tp02">해류</h2> : null}
                    {mode === 'basic' ? <p className="ze01">+</p> : null}
                    <h2 className="tp08">해수온도</h2>
                    <h2 className="tp06">@surface</h2>
                </div>
            } else if (type === "slr") {
                return <div className="btma_tit01 cl">
                    {mode === 'basic' ? <h2 className="tp02">해류</h2> : null}
                    {mode === 'basic' ? <p className="ze01">+</p> : null}
                    <h2 className="tp11">해수높이</h2>
                    <h2 className="tp06">@surface</h2>
                </div>
            }
    }

    const unitToggle = (type, mode) => {
        let unitIndex;
        const unitList = products.getUnitList(type);

        if (type === 'wind' && mode !== 'areaMean') {
            for (unitIndex = 0; unitIndex < unitList.length; unitIndex++) {
                if (primaryUnit.label === unitList[unitIndex].label) break;
            }
            if (unitIndex >= unitList.length - 1) unitIndex = 0;
            else unitIndex++;
            setPrimaryUnit(products.getUnitList(type)[unitIndex]);
        } else {
            for (unitIndex = 0; unitIndex < unitList.length; unitIndex++) {
                if (overlayUnit.label === unitList[unitIndex].label) break;
            }
            if (unitIndex >= unitList.length - 1) unitIndex = 0;
            else unitIndex++;
            setOverlayUnit(products.getUnitList(type)[unitIndex]);
        }
        if (overlayType === 'wind' || overlayType === 'currents') {
            //오버레이가 바람,해류인경우는 컬러바와 현재클릭지점 값을 업데이트 해야함
            earthController.colorBarUnitUpdate(products.getUnitList(type)[unitIndex]);
            earthController.drawBasicLocationPoint(products.getUnitList(type)[unitIndex]);
        } else {
            //오버레이가 바람,해류가 아닐때는 Primary단위변경을 클릭해도
            // 컬러바와 현재클릭지점 값이 변하면 안됨
            //왜냐하면 컬러바와 현재값은 Primary가 아니라 Overlay를 표출하고 있기 때문
            //wind와 currnets는 단위가 같으므로 currents인 경우에도 wind로 type이 넘어옴
            if (type === 'wind') return;
            else {
                //오버레이가 바람,해류가 아니면서 오버레이의 단위변경을 클릭한 경우임, 이경우는 업데이트가 되어야함
                earthController.colorBarUnitUpdate(products.getUnitList(type)[unitIndex]);
                earthController.drawBasicLocationPoint(products.getUnitList(type)[unitIndex]);
            }
        }
    }

    const handleClickDownload = () => {
        const coords = `${Math.abs(Number(climateData.header.coord[1]).toFixed(2))}${Number(climateData.header.coord[1]) > 0 ? 'N' : 'S'}, ${Math.abs(Number(climateData.header.coord[0]).toFixed(2))}${Number(climateData.header.coord[0]) > 0 ? 'E' : 'W'}`
        earthController.downloadAverageAnnualTimeSeries(coords);
    }

    const handleChangePeriodSlide = (e) => {
        let sliderValue = Number(e.target.value);
        if (overlayType === 'slr') { //해수면 고도는 1년 단위 데이터밖에 없으므로 보정해줌
            if (Math.abs(sliderValue - periodValue) === 1) {
                //sliderValue는 earth.js에서 gridAgent.submit(buildGrids);코드가 실행되기전
                //조건문에서 무조건 1월달로 맞춰진다.
                //좌로 이동시는 1월에서 1달전인 12월로만 되어도 아래 1월로 맞춰주는 코드 때문에 1년 단위로 움직인다.
                //하지만 우로 이동시는 1월로 맞추는 코드때문에 1년후로 갈 수 없다.
                //따라서 아래 코드로 우로 이동시 12칸 이동하는 코드를 추가하였다.
                sliderValue = (sliderValue - periodValue) > 0 ? sliderValue + 12 : sliderValue
            }
            sliderValue = sliderValue - (sliderValue % 12);
        }
        setPeriodValue(sliderValue);
        handleChangePeriodValue(sliderValue);
        µ.clearWorkerLocalStorage();
    }

    //period가 변경되었을때 configuration을 변경시키기 위한 함수
    //debounce를 사용하기 위해 usecallback함수로 뺌
    const handleChangePeriodValue = useCallback(_.debounce(function (value) {
            let years = parseInt(value / 12), months = value % 12;
            let scenario = earthController.configuration.get("scenario");
            let startDate = products.scenarioPeriod(scenario).startDate;
            var dateValue = new Date(Date.UTC(startDate.split("/")[0] * 1 + years, 0 + months, 1, 0, 0, 0));
            earthController.configuration.save(µ.dateToConfig(dateValue));
        }, 1000)
        , [earthController])

    const handleClickNani = (buttonType) => () => {
        if (buttonType === 'nani-now') {
            earthController.configuration.save({date: "current", hour: ""});
            const configurationScenario = earthController.configuration.get("scenario");
            let startDate = products.scenarioPeriod(configurationScenario).startDate;
            startDate = new Date(Date.UTC(startDate.split("/")[0] * 1, 0, 1, 0, 0, 0)); // 1860/01/01
            const date = earthController.configuration.get("date") === "current"
                ? new Date(Math.floor(Date.now() / staticVariable.THREE_HOURS) * staticVariable.THREE_HOURS)
                : new Date(earthController.configuration.get("date"));
            let sliderValue = (date.getFullYear() - startDate.getFullYear()) * 12 + (date.getMonth() - startDate.getMonth());
            if (sliderValue > staticVariable.PERIOD_MAX) sliderValue = staticVariable.PERIOD_MAX;
            if (sliderValue < 0) sliderValue = 0;
            setPeriodValue(sliderValue);
        } else if (buttonType === "nani-backward-most") {
            earthController.navigate(-100);
            const before20year = periodValue - 240; //20년
            setPeriodValue(before20year > 0 ? before20year : 0);
        } else if (buttonType === "nani-backward-more") {
            earthController.navigate(-10);
            const before1year = periodValue - 12; //1년
            setPeriodValue(before1year > 0 ? before1year : 0);
        } else if (buttonType === "nani-backward") {
            earthController.navigate(-1);
            const before1mon = periodValue - 1; //1개월
            setPeriodValue(before1mon > 0 ? before1mon : 0);
        } else if (buttonType === "nani") {
            if (periodPlay === false) {
                // d3.select("#nani").property("title", "stop");
                setPeriodPlay(true);
            } else {
                // d3.select("#nani").property("title", "start");
                setPeriodPlay(false);
            }
        } else if (buttonType === "nani-forward") {
            earthController.navigate(+1);
            const after1mon = periodValue + 1;
            setPeriodValue(after1mon < staticVariable.PERIOD_MAX ? after1mon : staticVariable.PERIOD_MAX);
        } else if (buttonType === "nani-forward-more") {
            earthController.navigate(+10);
            const after1year = periodValue + 12;
            setPeriodValue(after1year < staticVariable.PERIOD_MAX ? after1year : staticVariable.PERIOD_MAX);
        } else if (buttonType === "nani-forward-most") {
            earthController.navigate(+100);
            const after20year = periodValue + 240;
            setPeriodValue(after20year < staticVariable.PERIOD_MAX ? after20year : staticVariable.PERIOD_MAX);
        } else {
            console.error("invalid buttonType: ", buttonType);
        }
    }

    //최초 로드시 한번만 실행
    useEffect(() => {
        if(typeof(Worker) !== "undefined") {
            primaryWorker.current = new Worker('workers/counter.js');
            overlayWorker.current = new Worker('workers/counter.js');
            primaryWorker.current.onmessage = overlayWorker.current.onmessage = function (event) {
                const file = event.data;
                localStorage.setItem(file.url, JSON.stringify(file.data));
            };
        }
    },[])

    //기간플레이 작동/정지 했을때 사이드이펙트
    useEffect(() => {
        if (periodPlay === true) {
            // earthController.configuration.save({ periodPlay:periodPlay });
            //바람 애니메이션 정지
            // earthController.configuration.save({windAnimation: false});
            if(typeof(Worker) !== "undefined") {
                //인터폴레이션이 아직 끝나지 않으면 대기
                if (earthController.configuration.get("interpolateEnd") === false) {
                    waitIntervalId.current = setTimeout(() => {
                        setInterpolateWait(interpolateWait + 1);
                    }, 50);
                    return;
                } else {
                    setInterpolateWait(0);
                }
                //워커에게 데이터 파일 로드를 위임함
                let level;
                if (earthController.configuration.get("level").indexOf('hPa') === -1) { //고도가 없는 경우
                    //오버레이 변수가 바람 혹은 기온일 경우는 고도가 있는 경우와 구분하기 위해 surface-level-이 level 변수에 들어간다
                    if (earthController.configuration.get("overlayType") === 'default' || earthController.configuration.get("overlayType") === 'wind' || earthController.configuration.get("overlayType") === 'temp') level = 'surface-level-';
                    else level = ''; //나머지는 고도가 필요 없기에 level변수는 넣지 않는다
                } else {//고도가 있는 경우
                    level = 'isobaric-' + earthController.configuration.get("level") + '-';
                }

                if (earthController.configuration.get("overlayType") !== 'slr') {
                    overlayWorker.current.postMessage( //일반 변수 데이터를 로드하는 워커(바람 포함)
                        {
                            rootPath: staticVariable.WEATHER_PATH,
                            date: earthController.configuration.get("date"),
                            scenario: earthController.configuration.get("scenario"),
                            param: earthController.configuration.get("param"),
                            overlayType: earthController.configuration.get("overlayType") === 'default' ?
                                (earthController.configuration.get("param") === 'wind' ? 'wind' : 'currents')
                                : earthController.configuration.get("overlayType"),
                            level: level
                        }
                    );
                    if (earthController.configuration.get("overlayType") !== 'default' && !(earthController.configuration.get("overlayType") === 'wind' || earthController.configuration.get("overlayType") === 'currents')) {
                        primaryWorker.current.postMessage( //바람, 해류변수 데이터를 로드하는 워커(바람, 해류변수가 아닌경우 실행됨)
                            {
                                rootPath: staticVariable.WEATHER_PATH,
                                date: earthController.configuration.get("date"),
                                scenario: earthController.configuration.get("scenario"),
                                param: earthController.configuration.get("param"),
                                overlayType: earthController.configuration.get("param") === 'wind' ? 'wind' : 'currents',
                                level: earthController.configuration.get("overlayType") === 'temp' ? level : earthController.configuration.get("param") === 'wind' ? 'surface-level-' : ''
                            }
                        );
                    }
                }
            }
            let scenario = earthController.configuration.get("scenario");
            let scenarioPeriod = products.scenarioPeriod(scenario);
            periodIntervalId.current = setTimeout(() => {
                if (earthController.configuration.get("date") === scenarioPeriod.endDate) {
                    earthController.configuration.save({date: scenarioPeriod.startDate, hour: "0000"});
                    setPeriodValue(0);
                    return;
                }
                if (earthController.configuration.get("overlayType") === 'slr') {
                    //slr변수는 1년단위로 이동해야함
                    earthController.navigate(+10);
                    setPeriodValue(periodValue + 12);
                } else {
                    earthController.navigate(+1);
                    setPeriodValue(periodValue + 1);
                }
            }, 5000);
            return () => {
                clearTimeout(periodIntervalId.current);
                clearTimeout(waitIntervalId.current);
            }
        } else if (periodPlay === false) {
            clearTimeout(periodIntervalId.current);
            clearTimeout(waitIntervalId.current);
            if (earthController.configuration) {
                const toggleForColorScaleUpdate = earthController.configuration.get("toggleForColorScaleUpdate");
                earthController.configuration.save({ windAnimation: true, toggleForColorScaleUpdate: !toggleForColorScaleUpdate});
            }
        }
    },[periodPlay, periodValue, interpolateWait]);

    return isMobile ?
        <PeriodControlMobile menuDisplayToggle={menuDisplayToggle} showVicennialAreaMean={showVicennialAreaMean} getParamElement={getParamElement} climateData={climateData} setClearMouseModeAction={setClearMouseModeAction}
                             earthController={earthController} tbodyRef={tbodyRef} unitToggle={unitToggle} getOverlayClassName={getOverlayClassName} overlayUnit={overlayUnit} colorGradientList={colorGradientList}
                             showVicennialLocationAverage={showVicennialLocationAverage} handleClickDownload={handleClickDownload} primaryUnit={primaryUnit} handleClickNani={handleClickNani} periodPlay={periodPlay}
                             periodValue={periodValue} handleChangePeriodSlide={handleChangePeriodSlide} overlayType={overlayType} mouseMode={mouseMode}></PeriodControlMobile> :
        <PeriodControlPc menuDisplayToggle={menuDisplayToggle} showVicennialAreaMean={showVicennialAreaMean} getParamElement={getParamElement} climateData={climateData} setClearMouseModeAction={setClearMouseModeAction}
                         earthController={earthController} tbodyRef={tbodyRef} unitToggle={unitToggle} getOverlayClassName={getOverlayClassName} overlayUnit={overlayUnit} colorGradientList={colorGradientList}
                         showVicennialLocationAverage={showVicennialLocationAverage} handleClickDownload={handleClickDownload} primaryUnit={primaryUnit} handleClickNani={handleClickNani} periodPlay={periodPlay}
                         periodValue={periodValue} handleChangePeriodSlide={handleChangePeriodSlide} overlayType={overlayType}></PeriodControlPc>
}

export default PeriodControl;
